<template>
  <div class="table-footer-menu">
    <div v-if="this.numOfRecords > 0">
      <span class="table-page-item"> Rows per page </span>
      <span style="float: left">
        <select
          class="form-control mx-input table-page-selector"
          v-on:change="onPagePerPageChange($event)"
        >
          <option
            v-for="option in pageOptions"
            :value="option.value"
            :key="option.id"
            :selected="option.id == numPerPage"
          >
            {{ option.value }}
          </option>
        </select>
      </span>
      <span class="table-page-item"
        >Entries: {{ this.pageStart }} - {{ this.pageEnd }}
      </span>

      <span style="margin-right: 10px">
        <a
          @click="goPrevious"
          class="table-arrows"
          v-if="previousArrowVisible == true"
          >
           <img src="../assets/left-arrow.svg"  />
          </a
        >
      </span>
      <span style="margin-right: 10px">
        <!-- <a
          @click="goNext"
          v-if="nextArrowVisible == true"
          class="table-arrows"
          >&#62;</a
        > -->
        <a
          @click="goNext"
          v-if="nextArrowVisible == true"
          class="table-arrows"
          >
      <img src="../assets/right-arrow.svg"  />
          </a>
      </span>
    </div>
  </div>
</template>

<script>
// import EmsRow from "./EmsRow";
export default {
  name: "TableMenu",
  props: ["reports"],
  components: {
    // EmsRow,
  },
  data() {
    return {
      name: "EmsMonitorTable",
      numPerPage: 10,
      currentPage: 1,
      pageOptions: [
        { id: 10, value: 10 },
        { id: 20, value: 20 },
        { id: 30, value: 30 },
      ],
    };
  },
  methods: {
    makeNewSelection: function () {
      // alert("this.pageEnd"+this.pageEnd);
      let pageSelection = {};
      // alert("this.pageStart"+this.pageStart)
      // alert("this.pageEnd"+this.pageEnd)
      pageSelection.start = this.pageStart - 1;
      pageSelection.end = this.pageEnd;
      this.$emit("changedSelect", pageSelection);
    },
    onPagePerPageChange: function (event) {
      // alert("step 1"+JSON.stringify(event.target.value))
      this.numPerPage = Number(event.target.value);
      this.currentPage = 1;
      this.makeNewSelection();
    },
    goPrevious: function () {
      this.currentPage = this.currentPage - 1;
      this.makeNewSelection();
    },
    goNext: function () {
      this.currentPage = this.currentPage + 1;
      this.makeNewSelection();
    },
  },

  computed: {
    numOfRecords() {
      return this.reports?.length;
    },

    pageStart() {
      let tempPageStart = 0;
  // alert("pageStart step1:"+tempPageStart);


// alert("this.numPerPage"+this.numPerPage+"this.currentPage"+this.currentPage)
      // tempPageStart =
      //   this.numPerPage * this.currentPage - this.numPerPage + this.currentPage;
      // tempPageStart = (this.numPerPage * this.currentPage)+1
      tempPageStart=((this.numPerPage*(this.currentPage)+1)-this.numPerPage)
    //  alert("pageStart step2:"+tempPageStart);

      // if (this.numOfRecords < tempPageStart) {
      //  alert("exeresis");
      //  tempPageStart=((this.currentPage-1)*10)+1
      // }
  // alert("pageStart step3:"+tempPageStart);
      return tempPageStart;
    },
    pageEnd() {
      let tempPageEnd;
      tempPageEnd = this.numPerPage * this.currentPage;
// alert("tempPageEnd"+tempPageEnd)
      if (this.numOfRecords < tempPageEnd) {
        tempPageEnd = this.numOfRecords;
      }
      return tempPageEnd;
    },
    previousArrowVisible() {
      let showArrow = false;
      let tempPageStart;

      tempPageStart = this.numPerPage * this.currentPage;

      if (tempPageStart > this.numPerPage) {
        showArrow = true;
      }
      return showArrow;
    },
    nextArrowVisible() {
      let showArrow = false;

      if (this.numOfRecords > this.pageEnd) {
        showArrow = true;
      }
      return showArrow;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
